function subscribe($scope, serv, topic, fn) {
  var subj = serv.sub(topic, fn),
    unsub = subj && subj.unsub && typeof subj.unsub === 'function' ? subj.unsub : angular.noop;

  $scope.$on('$destroy', unsub);
}

angular.module('bbl.directives.greeting-cta', [])
.directive('greetingCta', ['Auth', 'Api', '$http', 'modals', function(Auth, Api, $http, modals) {
  var userInfo, lines;

  return {
    restrict: 'EA',
    template: '<div ng-if="showVoiceoverCTA"><div class="btn btn-primary" ng-click="showVoiceoverNumberModal();">{{\'Get your professional\' |translate}}<br />{{\'Voiceover Greeting\' |translate}}</div></div>',
    link: function($scope) {
      function checkCta() {
        if (!userInfo || !userInfo.company || !lines) {
          return;
        }

        var hideCtaForTrial = !userInfo.plan || userInfo.plan.trial_period_days;
        var hasOneLineAdded = lines.length == 1;
        var didntRequestGreeting = (!localStorage.getItem('greeting_requested') && !userInfo.company.requested_greeting);

        $scope.showVoiceoverCTA = !hideCtaForTrial && hasOneLineAdded && didntRequestGreeting;
      }

      $scope.$on('$routeChangeSuccess', checkCta());

      Auth.getUserInfo().catch(angular.noop).then(function(data) {
        userInfo = data;
        checkCta();
      });

      subscribe($scope, Api.bridges, function(data) {
        lines = data;
        checkCta();
      });

      $scope.$root.showVoiceoverNumberModal = function() {
        var companyName = (userInfo.company||{}).name;

        if (!companyName) {
          companyName = "YOUR COMPANY NAME";
        }

        $scope.voiceover_config = {step: 0};
        $scope.INFO = $scope.INFO || {};
        $scope.INFO.voiceover = "Welcome to the " + companyName + " conference line. Your conference will begin shortly.";
        $scope.voiceoverModal = modals.voiceover($scope).modal();

        // get the greetings
        $http.get('/greetings/api/v1/greetings/?format=json')
          .then(function(result){
            var greetingsObj = result.data.objects || [];
            $scope.greetings = greetingsObj.filter(function(item){
              return !!item.user.is_active;
            });
          });
      };

      $scope.saveVoiceOverData = function() {
        var number = $scope.number ? $scope.number.number : lines[0].bridge_number;
        var data = $.param({
          number: number,
          voiceover: $scope.INFO.voiceover,
          artist_id: $scope.INFO.artist_id
        });

        $http.post('/bridges/api/v1/set-voiceover', data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }).then(function() {
          localStorage.setItem('greeting_requested', true);
          checkCta();
        }, function() {
          console.log("error config number");
        });
      };
    }
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/greeting-cta.js
 ** module id = 186
 ** module chunks = 0
 **/